import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { productionPeriod } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { withRouter } from 'react-router-dom';
import { cartPath } from 'utils/paths';

const mapStateToProps = combineSelectors({
  productionPeriod,
});

export const title = ({ reviewString, checkoutString }) =>
  `${reviewString} & ${checkoutString}`;

export const inCartView = ({ location }) => location.pathname === cartPath;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['checkoutString', 'checkoutProcessString', 'reviewString'],
  }),
  connect(mapStateToProps),
  withRouter,
  addProps({ title, inCartView }),
  flattenProp('dealershipSummary'),
);
